export default __webpack_public_path__ + "static/media/icon_handyqr-1.45cadf9a.jpg";